import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { AppDialog } from '../../../components/common/CustomMdal';
import { Images } from '../../../utils/imageConstants';

interface TeamCreatedSuccessModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  teamName: string;
  teamId: string;
  joinLink?: string;
  qrCodeUrl?: string;
  onDone: () => void;
  /** Override title, e.g. "Share Team" when opened from Share button */
  title?: string;
}

function TeamCreatedSuccessModal({
  open,
  onOpenChange,
  teamName,
  teamId,
  joinLink = `https://criccenter.in/join/team/AX${teamId?.slice(-4) || '290'}`,
  onDone,
  title,
}: TeamCreatedSuccessModalProps) {
  const displayTitle = title ?? 'Team Created Successfully!';
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(joinLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShareQr = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: `Join ${teamName}`,
          text: `Join ${teamName} on CricCenter: ${joinLink}`,
          url: joinLink,
        });
      } else {
        handleCopy();
      }
    } catch {
      handleCopy();
    }
  };

  const handleDone = () => {
    onDone();
    onOpenChange(false);
  };

  return (
    <AppDialog open={open} onOpenChange={onOpenChange} title="" showCloseIcon={false} size="sm" className="team-created-success-dialog">
      <div className="team-created-success">
        <div className="team-created-success-icon-wrap">
          <img src={Images.success_icon} alt="" className="team-created-success-icon" />
        </div>
        <h2 className="team-created-success-title">{displayTitle}</h2>
        <p className="team-created-success-message">
          Your team &apos;{teamName}&apos; is now ready. CricCenter Team ID : <strong>{teamId}</strong>
        </p>
        <div className="team-created-invite team-created-invite-qr">
          <h3>Invite through QR Code :</h3>
          <div className="team-created-qr-wrapper">
            <QRCodeSVG value={joinLink} size={180} level="M" includeMargin />
          </div>
          <button type="button" className="team-created-share-btn" onClick={handleShareQr}>
            <span>Share this QR code to invite players</span>
            <img src={Images.share_icon} alt="" />
          </button>
        </div>
        <div className="team-created-invite">
          <h3>Invite through Link :</h3>
          <div className="team-created-link-field">
            <input type="text" readOnly value={joinLink} className="team-created-link-input" />
            <button
              type="button"
              className="team-created-copy-btn"
              onClick={handleCopy}
              aria-label="Copy link"
            >
              <img src={Images.statgpt_copy_icon} alt="" />
            </button>
          </div>
          {copied && <span className="team-created-copied">Copied!</span>}
        </div>
        <div className="team-created-footer">
          <button type="button" className="team-created-done-btn" onClick={handleDone}>
            Done
          </button>
        </div>
      </div>
    </AppDialog>
  );
}

export default TeamCreatedSuccessModal;
